import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ITypeExpenses } from '../interfaces/expenses/itypeExpenses';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TypeExpensesService {
  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get(`${environment.url}/expense_types`).pipe(map((res: any) => res['hydra:member'])) as Observable<
      ITypeExpenses[]
    >;
  }
}
